export default __webpack_public_path__ + "83e54d267a16981afe2e81efa38bf130.png";